import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ApprovedExpert from '../../../widgets/approvedExpert/ApprovedExpert'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  getSchemaAssignExpertMuti,
  getSchemaSendAssignExpert,
  getSchemaSendAssignExpertMulti,
} from '../../../redux/actions/assignExpert'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SendSelectedExpertMulti from '../../../widgets/sendSelectedExpert/SendSelectedExpertMulti'
import { Message, Row } from 'rsuite'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import pathname from '../../../constants/pathname'
import { getReviewResultMutiData } from '../../../redux/actions/reviewSummary'

export default function SendAssignExpertMulti() {
  const SELECTED_EXPERT = 'selectedExpertMulti'

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isReLoading, setIsReLoading] = useState(false)
  const [requestBody, setRequestBody] = useState()
  const [projectList, setProjectList] = useState()
  const [projectIdList, setProjectIdList] = useState()
  const [selectedExpert, setSelectedExpert] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  let history = useHistory()

  useEffect(() => {
    handleLoad()
  }, [])

  const handleLoad = () => {
    handleGetSchema()
    // if (selectedExpert?.length < 1 && !schema?.reviewerSelectedList?.itemsList) {
    //   // return history.push(`${pathname.proposal.review.assignMulti}/${projectId}`)
    // }
    setSelectedExpert(getSelectedExpertMulti())
  }

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let request = getRequestBody()
      //console.log('handleGetSchema request', request)
      const _schema = await getSchemaSendAssignExpertMulti(request, 5, 1)
      //console.log('handleGetSchema response', _schema)
      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      let request = getRequestBody()
      console.log('handleReload request', request, 'pagesize', pagesize, 'pagenumber', pagenumber)
      const response = await getReviewResultMutiData(request, pagesize, pagenumber)
      setProjectList(response)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const getRequestBody = () => {
    let request = requestBody
    if (!request) {
      let idList = sessionStorage.getItem('mutiReview')
      request = {
        id: idList,
        groupId: projectId,
      }
    }

    setProjectIdList(request?.id?.split(','))
    setRequestBody(request)
    return request
  }

  const getSelectedExpertMulti = () => {
    let _selectedExpert = []
    try {
      let datas = JSON.parse(sessionStorage.getItem(SELECTED_EXPERT) || [])

      _selectedExpert = datas.filter((e) => e?.isOnline || e?.isSelected)

      // _selectedExpert = JSON.parse(sessionStorage.getItem(SELECTED_EXPERT)) || []
    } catch (e) {}

    return _selectedExpert
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />
      {/* {selectedExpert?.length < 1 && ( //&& !schema?.forms?.reviewerApproveList?.itemsList?.length > 0
        <Message
          style={{ marginBottom: 10 }}
          showIcon
          type="warning"
          description="ไม่มีรายชื่อผู้ทรงที่เลือกไว้เพื่อส่งเสนอ กรุณาไปเลือกผู้ทรงคุณวุฒิก่อน"
        />
      )} */}

      {schema?.forms?.reviewerApproveList && (
        <div>
          <ApprovedExpert schema={schema.forms.reviewerApproveList} />
          <br />
        </div>
      )}

      {/* {selectedExpert?.length > 0 && ( */}
      <div>
        <SendSelectedExpertMulti
          schema={schema.forms}
          header="รายชื่อผู้ทรงคุณวุฒิที่เลือก"
          selectedExpert={selectedExpert}
          projectIdList={projectIdList}
          onComplete={handleLoad}
        />
        <br />
      </div>
      {/* )} */}

      {projectList && (
        <>
          <ProjectDataTable
            schema={projectList}
            // single={{
            //   enable: true,
            //   buttonText: projectList.buttonText || 'ส่งพิจารณา',
            //   iconByStatus: true,
            //   hideText: true,
            // }}
            pagination={true}
            onReload={handleReload}
            loading={isReLoading}
          />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}
